import { Expose } from "class-transformer";

export class UpdateTaskFileDto {
  @Expose()
  isPublic: boolean;

  @Expose()
  technicalReportSectionId?: string | null;
}
